import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'ProductIdDisplay',
        caption: 'Product',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        fixed: true
    },
    {
        dataField: 'Quantity',
        caption: 'Quantity',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        isEditable: true,
        alignment: 'right'
    },
    {
        dataField: 'Price',
        caption: 'Price',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        isEditable: true,
        alignment: 'right'
    },
    {
        dataField: 'Discount',
        caption: 'Discount',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        alignment: 'right',
        isEditable: true,
    },
    {
        dataField: 'Total',
        caption: 'Total',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        allowEditing: false,
        alignment: 'right'
    },
    {
        dataField: 'Description',
        caption: 'Description',
        minWidth: COLUMN_SIZE.LongDescription,
        width: COLUMN_SIZE.LongDescription,
        allowSorting: false,
        isEditable: true,
    },
    {
        dataField: 'Comment',
        caption: 'Comment',
        minWidth: COLUMN_SIZE.LongDescription,
        width: COLUMN_SIZE.LongDescription,
        allowSorting: false,
        allowEditing: false,
    },
    {
        dataField: 'CreditNoteLineId',
        visible: false,
    },
    {
        dataField: 'ProductId',
        visible: false,
    },
];

export const FieldName = {
    quantity: 'Quantity',
    product: 'ProductId',
    price: 'Price',
};

export const FastEntryEnabledStatus = ['Preparing', 'Modifying'] as const;
